module.exports = {
  Root: {
    Basic: {
      Failed: "Failed",
      Success: "Success",
      Result: "Result",
      Select: "Select",
      Cancel: "Cancel",
      Confirm: "Confirm",
      OK: "OK",
      Ok: "OK",
      Tips: "Tips",
      Warning: "Warning",
      Method: "Method",
      Required: "Required",
      MaxLength: "The length is limited to {num} characters",
      Submit: "Submit",
      Search: "Search",
      Reset: "Reset",
      More: "More",
      Back_to_Homepage: "Back to Homepage",
      delete: "Delete",
      no: "No"
    },
    Import: {
      Job: "Job",
      No: "No.",
      row_of_sheet: "Row of sheet",
      reason_of_fails: "Reason of fails",
      File: "File",
      no_data: "No results found",
      import: "Import",
      upload: "Upload",
      refresh: "Refresh",
      refresh_notice: "Click on “Refresh” to view the latest status.",
      view_result: "View Result",
      Started_at: "Started at",
      Status: "Status",
      total_count: "Total Count",
      error_count: "Error Count",
      success_count: "Success Count",
      Action: "Action",
      got_it: "Got it!",
      execution_history: "Execution History",
      import_history: "Import History",
      download_template: "Download Template",
      job_description: "Job Description",
      import_products: "Import Products",
      import_completed_at: "Import completed at",
      importing:
        "Importing, please be patient. The result will be displayed in the execution history list.",
      import_products_desc:
        "You can import products to PIM from a XLSX file. We recommend downloading the template before running an import.",
      select_a_file: "Select a file",
      Please_select_an_org: " Please select an organization first",
      rules_title: "Import Rules",
      import_run_tip: "When the import is running,you can not view result",
      Please_confirm_the_org:
        "Please confirm the organization where the product needs to be imported",
      Confirme_or_switch_org: "Confirme or switch organization",
      Import_Products: "Import Products",
      Import_SKU: "Import SKU",
      Import_Price: "Import Price",
      Import_Image: "Import Image",
      Import_Channel_Info: "Import Channel Info",
      DownloadTemplate: "Download Source File",
      please_enter_verification_code: "Please enter verification code",
      Default_Attributes: "Default Attributes",
      Include_Customized_Attributes: " Include Customized Attributes",
      importType: "Import Type"
    },
    Export: {
      export: "Export",
      export_all: "Export All",
      history: "Export History",
      time: "Export Time",
      requester: "Requester",
      language: "Language",
      status: "Status",
      action: "Action",
      no_history: "No history",
      choose_language: "Choose Language",
      loading: "Loading...",
      download: "Download",
      refresh_notice: "Click on “Refresh” to view the latest status.",
      page_notice:
        "Export products, attributes or other information to a local file.",
      exporting: "Product data is being prepared for download...",
      refresh: "Refresh",
      export_all_notice:
        "Are you sure to export all products? This can take long time if there're a lot products.",
      org: "Org",
      Please_confirm_the_org: "Please confirm the organization",
      confirm_org: "Confirm the organization",
      send: "Send",
      resends: "Resend ({x}s)",
      resend: "Resend",
      enter_code: "Enter Code",
      Account_Verification: "Account Verification",
      Account_Verification_Tips:
        "To protect the data security, we need to verify your account. We will send a verification code to your email ({x}) and your mobile ({y}).",

      exportType: "Export Type"
    }
  }
};
